module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAMAAAAbzM5ZAAAAP1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////9Du/pqAAAAFHRSTlMAiKWW6azzMyIe693Vzpl5cGZWVMJp1KYAAABkSURBVCjP7ZJLDoAgDAWflSKIgh/uf1aJTQ1E3bpyVpPpsg/wZHKFIQ84SXV2YLE4FKI4w4oELgRxi/xAiXPXMJ2xRwP98YP4/g7BpmTVobYCi97B98jXbMy+qTnA05grRvI4AAJvE3gSTRBRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-phone.png
// module id = 399
// module chunks = 2